import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useCallback, useRef, useState } from 'react';
import { mapErrorToApiError } from '../api-error';
export var useMutation = function useMutation(_ref) {
  var mutationFn = _ref.mutationFn,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError;
  var mutationFnRef = useRef(mutationFn);
  mutationFnRef.current = mutationFn;
  var onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;
  var onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSubmitting = _useState6[0],
    setIsSubmitting = _useState6[1];
  var mutate = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload, mutateCallback) {
      var _onSuccessRef$current, _mutateCallback$onSuc, response, _onErrorRef$current, _mutateCallback$onErr, apiError;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            _context.prev = 1;
            _context.next = 4;
            return mutationFnRef.current(payload);
          case 4:
            response = _context.sent;
            setData(response);
            (_onSuccessRef$current = onSuccessRef.current) === null || _onSuccessRef$current === void 0 || _onSuccessRef$current.call(onSuccessRef, response);
            mutateCallback === null || mutateCallback === void 0 || (_mutateCallback$onSuc = mutateCallback.onSuccess) === null || _mutateCallback$onSuc === void 0 || _mutateCallback$onSuc.call(mutateCallback, response);
            _context.next = 16;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            apiError = mapErrorToApiError(_context.t0);
            setError(apiError);
            (_onErrorRef$current = onErrorRef.current) === null || _onErrorRef$current === void 0 || _onErrorRef$current.call(onErrorRef, apiError);
            mutateCallback === null || mutateCallback === void 0 || (_mutateCallback$onErr = mutateCallback.onError) === null || _mutateCallback$onErr === void 0 || _mutateCallback$onErr.call(mutateCallback, apiError);
          case 16:
            _context.prev = 16;
            setIsSubmitting(false);
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 10, 16, 19]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  return {
    data: data,
    error: error,
    isSubmitting: isSubmitting,
    mutate: mutate
  };
};